
$(document).ready(function(){

    $('.supplier .marker a').click(function(){
        var id = $(this).data('id');
        google.maps.event.trigger(markers[id], 'click');
    });

});




//////////////////
// WEBPACK FOOTER
// ./assets/scripts/parts/map.js
// module id = 18
// module chunks = 0